import { Loader2, ShieldAlert } from "lucide-react";
import type { PropsWithChildren } from "react";
import { isVerifiedPortalOperator } from "../capabilities";
import { useAuth } from "../hooks/use-auth";

/** Gates portal-management UI to approved active admin or worker profiles. */
export function PortalOperatorGuard({ children }: PropsWithChildren) {
  const { isApproved, isLoading, profile } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center">
        <div className="flex items-center gap-2 text-muted-foreground text-sm">
          <Loader2 className="size-4 animate-spin motion-reduce:animate-none" />
          Checking portal access…
        </div>
      </div>
    );
  }

  if (!isVerifiedPortalOperator(profile, isApproved)) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center p-6">
        <div className="max-w-md rounded-lg border bg-card p-6 text-center shadow-sm">
          <ShieldAlert className="mx-auto mb-3 size-8 text-icon-secondary" />
          <h1 className="font-semibold text-lg">Portal management access required</h1>
          <p className="mt-2 text-muted-foreground text-sm">
            An approved active worker or admin profile is required to manage portal payments and
            document shares.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
